import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { toggleOpen } from "./assistant.slice";

const ASSISTANT_NAME = "Tomas";

/**
 * Header entry point for the assistant, sitting with the other header actions
 * (unsigned files, cart, notifications) rather than floating over the page.
 *
 * Renders nothing for non-Master users: v1 is Master-only server-side, so
 * everyone else would open a panel that can only answer 403.
 */
export const AssistantLauncher: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const role = useAppSelector((state) => state.authReducer.role);
  const isOpen = useAppSelector((state) => state.assistantReducer.isOpen);
  const isMaster = !!role?.permissionsgroups?.includes("Master");

  if (!isMaster) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => dispatch(toggleOpen())}
      title={t("assistant_title", { defaultValue: ASSISTANT_NAME })}
      aria-label={t("assistant_title", { defaultValue: ASSISTANT_NAME })}
      className={
        // 44px on a phone and tablet, where the button is a finger target
        "relative p-2 border-none rounded-sm transition-colors focus:outline-none max-lg:inline-flex max-lg:size-11 max-lg:items-center max-lg:justify-center " +
        (isOpen ? "bg-indigo-50" : "bg-transparent hover:bg-gray-100")
      }
    >
      <span
        className={
          "flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold " +
          (isOpen ? "bg-indigo-700 text-white" : "bg-indigo-600 text-white")
        }
      >
        T
      </span>
    </button>
  );
};

export default AssistantLauncher;
